export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const REPORT_BASE_URL = process.env.REACT_APP_REPORT_API_BASE_URL;

export const API_BASES = {
  CORE: BASE_URL,
  REPORT: REPORT_BASE_URL,
};
